{
  "ResultFields": {
    "role": "Role",
    "button": "Result fields",
    "title": "Result fields",
    "onlyMe": "Only for me",
    "line": "Second line",
    "lineLimit": "up to {{max}}",
    "lineEmpty": "Nothing under the name.",
    "order": "Second line in order",
    "noCatalog": "No fields to show.",
    "right": "On the right",
    "rightHint": "The pictures always come last.",
    "pictures": "Pictures",
    "reset": "Reset to default"
  },
  "ResourceFieldSections": {
    "label": "Resource fields",
    "groups": {
      "profile": "Profile",
      "contact": "Contact",
      "social": "Social",
      "custom": "Custom fields"
    }
  }
}
